export { default as Line } from './line';
export { default as Text } from './text';
export { default as Arc } from './arc';
export { default as Region } from './region';
export { default as Image } from './image';
export { default as DataMarker } from './data-marker';
export { default as DataRegion } from './data-region';
export { default as RegionFilter } from './region-filter';
export { default as Shape } from './shape';
export { default as Html } from './html';
//# sourceMappingURL=index.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/@antv/component/esm/annotation/index.js
// module id = null
// module chunks = 